import { Icon } from '../Icon';
import styles from './Rating.module.scss';

interface RatingProps {
  title: string;
  rating: number | string;
}

export const Rating = ({ title, rating }: RatingProps) => (
  <div className={styles.container}>
    <h1 className={styles.title}>{title}</h1>
    <div className={styles.ratingContainer}>
      <Icon width={16} height={16} name="coloredStar" />
      <h2 className={styles.rating}>{Number(rating).toFixed(1)}</h2>
    </div>
  </div>
);
